import { render, staticRenderFns } from "./IdentityProofInput.vue?vue&type=template&id=57c1c693&scoped=true"
import script from "./IdentityProofInput.vue?vue&type=script&lang=js"
export * from "./IdentityProofInput.vue?vue&type=script&lang=js"
import style0 from "./IdentityProofInput.vue?vue&type=style&index=0&id=57c1c693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c1c693",
  null
  
)

export default component.exports